import { Envs, Utils } from '../common';
const oldUIProducts = {
	//'1AN': {
	//	YASPAQZR: '001' //易安食品安全责任保险
	//},
	//HUAGUI: {
	//	HGDMDQSXMTJ: '001' //华贵大麦定期寿险(免体检版)
	//}
} as { [key: string]: { [key: string]: string } };

export const onCSMSHandled = (options: {
	vendorCode: string | undefined;
	productCode: string | undefined;
	productVersion: string | undefined;
}): boolean => {
	const { vendorCode = '', productCode = '', productVersion } = options;
	return (oldUIProducts[vendorCode] || {})[productCode] === productVersion;
};

// 忽略校验合约的产品
const ignoreAgreementCheckProducts = {
	hongk: {
		HKXGZX: '001' //弘康佑安意外保险
	}
} as { [key: string]: { [key: string]: string } };

export const ignoreAgreementCheck = (options: {
	vendorCode: string | undefined;
	productCode: string | undefined;
	productVersion: string | undefined;
}): boolean => {
	const { vendorCode = '', productCode = '', productVersion } = options;
	return (ignoreAgreementCheckProducts[vendorCode] || {})[productCode] === productVersion;
};


//可回溯产品定义
const GluttonProducts = {
	FXJK: {
		'FXLJYS2019': { //复星联合乐健一生中端医疗保险（2019版）
			'001': {
				EPLBKS: true,
			}
		},
		'FXMMBB': { //复星联合妈咪保贝少儿重大疾病保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXMMBBXSB': { //复星联合妈咪保贝（新生版）少儿重大疾病保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXBJX': { //复星联合倍吉星重大疾病保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXYSWY2021': { //复星益生无忧传染病医疗保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXAWYYWSH': { //复星爱无忧意外伤害
			'001': {
				EPLBKS: true,
			}
		},
		'FXJYB': { //复星家医保重大疾病保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXKLES': { //复星康乐一生（2021版）重大疾病保险
			'001': {
				EPLBKS: true,
			}
		},
		'FXLHCYB2020': { //复星超越保2020
			'001': {
				EPLBKS: true,
			}
		},
		'NETM7849PK': true,//复星联合妈咪保贝爱常在少儿重大疾病保险（A款）（互联网）
		'NETM0685QW': true, // 医联有盟瑞星保重大疾病保障计划
		'NETM0670RC': true, // 复星联合超越保无忧版长期住院医疗保险（费率可调）（互联网）
		'NETM9468DZ': true,
		'NETM0849ND': true,
		'NETM0551BK': true,
		'NETM9309DJ': true,
		'NETM2529SR': true,
		'NETM7730ZU': true,
		'NETM2996KS': true,
		'NETM4493UF': true,
	},
	'1AN': {
		'YAZYWYBZJH': true, //易安住院无忧保障计划
		'YAZHJTYWX': true,//  - 综合交通工具意外险
	},
	RHASSURANCE: {
		'RHBJLBDCJFZDJBBX': true,// - 瑞华-倍嘉乐保多次给付重大疾病保险
	},
	APIINS: {
		'YXFEJZHBZ': true, //亚太财险“永幸福”E家综合保障保险
		'NETM5270IC': true,
	},
	HIINS: {
		'HIINSRZZBX': true,//现代财产保险（中国）认知症保险
	},
	axa: {
		'AXAZYSHBWZYYLBX': true,//【安盛天平】卓越守护百万住院医疗保险（高血压患者专款）
		'AXAZYWYBWFABX2020': true,//【安盛天平】卓越无忧百万防癌保险2020版
		'AXAZYSHBWZYYLBXTNB': true,//【安盛天平】卓越无忧百万住院医疗保险（糖尿病专款）
		'AXAZYSHBWYLBX': true,//【安盛天平】卓越无忧百万住院医疗保险
		'AXAXYHGRYW': true,//安盛天平夕阳红个人意外伤害保险（2021版）
		'AXAZYBWGRYW': true,//安盛天平"卓越百万"个人意外伤害保险
		'AXAGRZHZYYL': true,//安盛天平个人综合住院医疗保险
		'AXAZYSHBWZYYL2022PLUSHLW': true,//安盛天平卓越守护百万住院医疗2022升级版
		'AXASHSGGRYW': true,//【安盛天平】安盛天平守护时光个人意外伤害保险(互联网专属)
		'AXAZYXXYLBX2023HLW': true,//【卓越馨选医疗保险(2023版)(互联网专属)
		'AXAZYLXJHLW': true,//安盛天平卓越旅行家（互联网专属）
		'AXAZXTXLXBXHLW': true,//安盛天平智行天下旅行保险（2018版）（互联网专属）
		'AXAZYSHBWZYYL2022HLW': true,//安盛天平卓越守护百万住院医疗2022版
		'AXASHWLXPX': true, //“守护未来”安盛学生平安保险
		'NETM9353FB': true,//卓越馨选医疗保险(2024版)(互联网专属)
		'NETM5910WT': true, // 卓越守护百万住院医疗保险2024版（互联网专属）
		'NETM0668SB': true, //卓越馨选医疗保险（2025版）（互联网专属）
		'NETM9522WB': true, //馨选无忧医疗保险（互联网专属）
		'NETM5148RW': true, //安盛智行天下全球旅行保险（互联网专属）
	},
	jdallianz: {
		'JDALGDETYLBX': true,//成长优享-高端儿童医疗保险（2021版）
		'JDALZABWYLBX': true,//京东安联臻爱百万医疗保险计划(甲状腺病特别版)
		'JDBDWYWGZ': true,//京不倒翁（新版）- 京东安联中老年人意外骨折保障计划
		'JDETYSL': true,//成长优享-京东安联私立儿童眼视力保险保障计
		'JDXXYMY': true,//小幸孕 - 京东安联母婴保障计划
		'JDJCYJGXBE': true,//京东安联京彩一家共享保额意外险保障计划
		'JDSLETCK': true,//成长优享-京东安联私立儿童齿科保险保障计划
		NETM1332LQ: true, // 成长优享家庭计划高端医疗保险（2024互联网版）
		NETM9828UY: true, // 畅享神州户外运动版(互联网版)
		NETM7747HJ: true, // 畅享神州团建研学版(互联网版)
		NETM7030MW: true, // 畅享神州休闲旅行版(互联网版)
		NETM3484JY: true, // 成长优享儿童高端医疗保险（2025互联网全国版）
		NETM4428GB: true, // 成长优享PLUS儿童高端医疗保险（2025联网北京版）
		NETM1564YI: true, // 萌宠放心保
		NETM1085MK: true, // 永达理出行保
	},
	HQ: {
		'HQYHJSZEZS': true,//横琴永恒金生增额终身寿险
		'HQCSYJZEZS': true,//横琴传世赢家增额终身寿险
		'HQYSDZDJBBX': true,//横琴优时代重大疾病保险
		'HQCSYHZEZS': true,//横琴传世壹號增额终身寿险
		'HQZXYSYLNJ': true,//横琴臻享一生养老年金保险
		'HQYABZSSX': true,//横琴优爱宝终身寿险
		'HQCSYHZXBZEZS': true,//横琴传世壹号尊享版终身寿险
	},
	HUAGUI: {
		HGDMDQSX2021: true, //华贵大麦2021定期寿险(免体检版)
		HGXAZSS: true, //华贵小爱终身寿险
		HGTMJ2021: true, //华贵大麦甜蜜家2021定期寿险
		HGDM2021TJB: true, //华贵大麦2021定期寿险体检版
		HGXATJB: true, //华贵小爱终身寿体检版
		HGQQNB: true, //华贵大麦全能保险
		HGDMDLB: true, //兜来保
		NETM9377EZ: true, //华贵大麦旗舰版A款定期寿险 (互联网专属)
        NETM2552LU: true, //华贵大麦甜蜜家2024定期寿险（互联网专属）
        NETM5306QU: true, //华贵大麦2024定期寿险（互联网专属）
		NETM9016EQ: true, //华贵麦兜兜2024少儿重大疾病保险（互联网专属）
		NETM3836KQ: true, //华贵大麦2026定期寿险（互联网专属）
		NETM6665ZT: true, //华贵大麦甜蜜家2026定期寿险（互联网专属）
		NETM8169QK: true, //华贵大麦甜蜜家2026A款定期寿险（互联网专属）
		NETM0341UX: true, //华贵大麦2026A款定期寿险（互联网专属）
	},
	KUNLUN: {
		'KLJKBDBB': true,//健康保（多倍版）重大疾病保险
		'KLJKBPHDBB': true,//健康保普惠多倍版重大疾病保险
		'KABJBBZJH': true,//康爱宝疾病保险
	},
	SHLIFE: {
		'SHRSYXZS': true,//上海人寿优选终身寿险
	},
	xint: {
		'XTRYRSSHYXBZDJBBX': true,//信泰如意人生守护（英雄版）重大疾病保险
		'XTRYZZSSX': true,//信泰如意尊终身寿险
		'XTRYZZSSX2': true,//信泰如意尊（2.0版）终身寿险 暂时先关闭
		NETM7651EB: true, // 信泰如意尊（泰来2026）终身寿险（互联网专属）
		NETM3506SU: true,
		NETM1771RD: true, //信泰及时雨（2026）重大疾病保险（互联网专属）
	},
	CHINALIFE: {
		TAXYLBX2020: true,//特安心医疗保险（2020版）
		AXG: true,//安心雇
		AXYSXB: true,//安心养舒心版
		BWAXL: true,//百万安心疗
		JLB: true,//家乐宝
		JYRQZHBX: true,//家用燃气综合保险
		XHZX: true,//熊孩子险
	},
	starrchina: {
		SDCQSBWYWBZJH: true,//史带永达理常青树百万意外保障计划
		SDCAZYJNLX: true,//史带永达理爱自由境内旅行保障计划3代
		SDCLNRYWBZ: true,//史带永达理老年人意外保障
		SDJNDTZBY: true,//史带永达理境内周边游旅行保障计划
		SDJNHWYD: true,//史带永达理户外运动
		NETM8676JI: true, //史带爱自由境内旅行保障(互联网版)
	},
	hongk: {
		HKXGZX: true //弘康佑安意外保险
	},
	CLL: {
		LJZGTYTHRZSSX: true
	},
	futurebaobei: {
		YCRYB: true //永诚任医保
	},
	AIXIN: {
		AXRSXXSNJBXWX: true,//爱心人寿心相随年金保险
		AXRSYLDYLNJBX: true,//爱心人寿养乐多养老年金保险
		AXRSYSHZEZSSX: true, //爱心映山红增额终身寿
		AXRSSHSCQYWX: true,//爱心人寿守护神长期意外险
	},
	PAMHI: {
		PAESBCQGRZYYL: true, // 平安e生保长期个人住院医疗
		PAESBCQGRZYYLHLW: true, // 平安e生保长期个人住院医疗(互联网版)
		PAESMBYLZH2023: true, // 平安e生保·慢病医疗险组合产品2023(互联网版)
		MJPAESMBYLZH2023: true, // 平安e生保·慢病医疗险组合产品2023(互联网版)
		PAESCQYL: true, // 平安e生保长期医疗
		ZHPAESBHLWCQYLBX: true, // 平安e生保互联网长期医疗保险（费率可调）产品组合
		ZHPAHLWZSFAFLKT: true, // 平安互联网终身防癌（费率可调）产品组合
		ZHPAESB2023MBBHLWBX: true, // 平安e生保2023（慢病版）互联网保险产品组合
		PAESFZJHLW: true, //平安e生福·重疾险（1年期）互联网专属保险产品组合
		NETM8075LP: true, //平安e生保 •互联网慢病医疗2023保险产品组合
		NETM6201TY: true, //平安e生保•互联网长期医疗（费率可调）保险产品组合
		NETM7821AU: true, //平安e生保互联网长期医疗保险（费率可调)

		PAESBHLWCQYLBXCPZH: true, // 平安e生保互联网长期医疗保险产品组合
		PAHLWTDYPFYYLBX: true, // 平安互联网特定药品费用医疗保险
        PAESBHLWYL2022BXCPZH: true, // 平安e生保互联网医疗2022保险产品组合
        NETS4067NY: true, // 平安附加互联网特需医疗保险H20078
        NETM8638PG: true, // 平安e生安心▪长期中端医疗险
        NETM6734BE: true, // 平安颐享易保高端医疗
        NETM5876MF: true, // 平安互联网颐享臻选高端医疗保险
        NETM2467BW: true, // 平安e惠保▪互联网百万医疗医疗（易核版）
        NETM0204SR: true, // 安欣保长期医疗险
        NETM1907US: true, // 平安e生保互联网住院（2023版）
        NETM8242FC: true, // 平安互联网终身防癌（费率可调）保险产品组合
        NETM2231UP: true, // 平安e生保互联网2025医疗保险
        NETM2488WC: true, // e生安心▪中端医疗险（易保版）
		NETM1935SG: true, // 平安健康岁月长安特定疾病保险（互联网）
	},
	zhongan: {
		ZXES2021: true, //尊享e生2021版
		NXBYWX: true,   //暖心保意外险
		NETM7810GK: true, //众安宠物险
		NETM1880UE: true, //尊享宝贝·少儿高端医疗险
		NETM5685NB: true, //众安在线尊享e生2025
		NETM4878PW: true, //众安在线孝欣保中老年人综合意外
		NETM9183DE: true, //众安在线众民保·百万医疗险
		NETM6215SR: true, //众安在线少儿意外2024
		NETM5936HL: true, //众民保·中高端医疗险
		NETM0211YT: true, //众民保·百万重疾险
		NETM9402KV: true, //众安在线尊享e生2025（转保版）
		NETM0457ZW: true, // 众安尊享e生·中高端医疗保险2024版
		NETM0444GV: true, // 众安牙美乐（隐适美版）
		NETM3286XF: true, // 众安牙美乐矫正版
		NETM2993ET: true, // 众安臻牙乐
		NETM0224BJ: true, // 众安悠牙乐
		NETM4024JH: true, // 众安伢牙乐
		NETM6320SW: true, // 众民保·复发险
		NETM3774VK: true, // 尊享宝贝·少儿高端医疗险2025版
		NETM8878PW: true, // 众安小当家少儿门急诊
		NETM5723BT: true, // 众民保·百万医疗险2025
		NETM0381QX: true, // 众民保·中高端医疗险
		NETM5210KH: true, // 尊享宝贝·少儿高端医疗险2025版（智享版）
		NETM4454BK: true, // 尊享e生·中高端医疗保险PLUS（2025版）
		NETM0241KX: true, // 尊享e生·中高端医疗保险2025版
	},
	chengwei: {
		NETM5201AP: true, // 太保福有余（2024A）终身寿险（互联网）
		NETM2472FZ: true, // 太保瑞有余(2024)年金保险(个养版)（计划一）
		NETM7772QE: true, // 太保瑞有余(2024)年金保险(个养版)（计划二）
		NETM4785QD: true, // 太保瑞有余(2024)年金保险（计划一）
		NETM2477KM: true, // 太保瑞有余(2024)年金保险（计划二）
		NETM0687XZ: true, // 太保福有余（2024）终身寿险（互联网）
		NETM6438KX: true, // 太保福有余（2025）终身寿险（互联网）
	},
	dingcheng: {
		dcdingfeng1hao: true,//鼎诚鼎峰1号终身寿险
	},
	fubang: {
		FBGAESFA: true,//富邦关爱e生·防癌医疗险
		FBXFEJBW: true,//富邦幸福e家·百万医疗险
		FBJJAXBJBX: true,//居家安心保（基本型）
	},
	TAIKANG_GI: {
		TKZXECKPH: true, //泰康E齿康588普惠计划
		TKZXECKPHHLWH5: true, //泰康E齿康588普惠计划(H5对接)
	},
	CPICGIA: {
		CPICJNTRAC: true, // 太平洋境内旅游意外险
		NETM5635EW: true, // 小蜜蜂3号综合意外险（互联网专属）
		NETM2151DF: true, //小蜜蜂5号综合意外险
		NETM0916YS: true, // 番茄种植险
	},
	HUIZE: {
		HUIXINANSEHLW2022: true,//慧馨安2022少儿重疾险（互联网专属）
		NETM6004PV: true, //小蜜蜂(轻享版)综合意外险
		NETM5635EW: true, // 小蜜蜂3号综合意外险（互联网专属）
		NETM2151DF: true, //小蜜蜂5号综合意外险
		NETM2008WD: true, //守卫者6号重大疾病保险
		NETM2154YF: true, //小医仙2号医疗险
		GFDEWHLW6: true, //达尔文6号重大疾病保险（互联网专属）
		NETM9393AQ: true, // 达尔文10号重大疾病保险
		NETM9932HF: true, // 小青龙5号少儿重大疾病保险（互联网）
		NETM8077PN: true, // 小医仙3号医疗险
		NETM3845UK: true, // 华贵大麦2024定期寿险（互联网专属）
		NETM6195IK: true, // 长相安长期医疗险(20年保证续保)个人版
		NETM1267VT: true, // 长相安长期医疗险(20年保证续保)家庭版
		NETM4390CJ: true, // 暖宝保3号少儿门急诊保险
		NETM2127AM: true, // 中荷互联网岁岁享3.0护理保险
		NETM0324YT: true, // 中荷互联网岁岁享2.0护理保险
		NETM1459TA: true, // 小淘气5号少儿重大疾病保险
		NETM0268TH: true, // 快享福2号终身年金保险
		NETM7862QC: true, // 小神童5号少儿意外险
		NETM1420EY: true, // 孝心安5号老年人意外险
		NETM9878XQ: true, // 长相安长期医疗险(20年保证续保)个人版（接力计划）
		NETM6639ND: true, // 长相安长期医疗险(20年保证续保)家庭版（接力计划）
		NETM9275UP: true, // 中英人寿福临门两全保险A款（互联网）个养专项
		NETM4746GJ: true, // 复星联合达尔文11号重大疾病保险（互联网专属）
		NETM5921RX: true, // 复星联合达尔文12号重大疾病保险（互联网专属）
		NETM1987AY: true, // 同方全球「臻爱2024」互联网两全保险
		NETM4421CH: true, // 君龙人寿守卫者7号重大疾病保险
		NETM4365BW: true, // 君龙人寿小青龙6号少儿重大疾病保险（互联网）
		NETR1631NV: true, // 复星联合星相守长期医疗险（20年保证续保）（个人版）
		NETM7948BR: true, // 复星联合星相守长期医疗险（20年保证续保）（家庭版）
    NETM8879LK: true, // 长相安2号长期医疗险(20年保证续保)(个人版)
    NETM3876BM: true, // 长相安2号长期医疗险(20年保证续保)(家庭版)
    NETM9965MN: true, // 长相安2号长期医疗险(20年保证续保)(个人版)(接力计划)
    NETM6809BS: true, // 长相安2号长期医疗险(20年保证续保)(家庭版)(接力计划)
	NETM4726SI: true, // 新华快享福3号终身年金保险（互联网）
	},
	CPICHE: {
		NETM7251CS: true, //蓝医保·终身防癌医疗险
	},
	PINGANGI: {
		NETM6244AG: true, //平安青海老年人意外险标准版(互联网)
		NETM6004PV: true, //小蜜蜂(轻享版)综合意外险
		MITM4820HC: true,
		NETM5561YP: true,
		NETM4911UZ: true,
		NETM4542JP: true, // 中国平安小顽童7号少儿意外险
		NETM8484QD: true,
	},
	CHUANGXIN: {
		NETM7091AW: true, //  北京人寿大黄蜂9号少儿重疾险
		NETM9017PS: true, //中国人保金医保百万医疗险
		NETM5782XB: true, //北京人寿大黄蜂10号少儿重疾险(全能版)
		NETM4953CZ: true, //中国人保金医保少儿长期医疗险(0免赔)产品组合
		NETM0988AU: true, //中国人保大护甲6号意外险(旗舰版)
		NETM4931MH: true, //复星保德信大黄蜂10号少儿重疾险
		NETM5980WN: true, //  君龙人寿超级玛丽9号重疾险
		NETM0528FQ: true, //君龙人寿超级玛丽10号重疾险
		NETM3990CZ: true, //君龙人寿超级玛丽11号重疾险
		NETM9589RZ: true, //北京人寿擎天柱8号定期寿险
		NETM1082EZ: true, //华泰保险一年期少儿重疾险2021
		NETM8218RE: true, //华泰保险一年期成人重疾险2021
		NETM9613VP: true,//北京人寿大黄蜂11号少儿重疾险(全能版)
		NETM3350RK: true, // 北京人寿擎天柱9号定期寿险(互联网专属)
		NETM4857JG: true, // 中国人保金医保2号长期百万医疗险
		NETM8346NQ: true, // 北京人寿大黄蜂12号焕新版重大疾病保险
		NETM6980BF: true, // 君龙人寿超级玛丽12号重大疾病保险
		NETM5011IR: true, // 中国平安小顽童6号少儿意外险
		NETM1659QB: true, // 阳光人寿互联网定期恶性肿瘤疾病保险
		NETM8219TA: true, // 海保人寿福多多1号重大疾病保险(福享版)
		NETM2503ZU: true, // 太平洋保险大护甲5号意外险（家庭版）
		NETM7236DJ: true, // 太平洋保险大护甲6号意外险（家庭版）
		NETM8570VW: true, // 利宝柏世利享医疗保险
		NETM4560DS: true, // 君龙人寿超级玛丽13号重大疾病保险
		NETM5936HL: true, // 众民保·中高端医疗险
		NETM0457ZW: true, // 众安尊享e生·中高端医疗保险2024版
		NETM5876MF: true, // 平安互联网颐享臻选高端医疗保险
		NETM1880UE: true, // 尊享宝贝·少儿高端医疗险
        NETM2552LU: true, //华贵大麦甜蜜家2024定期寿险（互联网专属）
		NETM9016EQ: true, //华贵麦兜兜2024少儿重大疾病保险（互联网专属）
		NETM9488LT: true, // 中英人寿鑫盈家终身寿险（互联网专属）
		NETM9179DM: true, // 众安保险尊享e生2025版百万医疗险
		NETM8970TD: true, // 太平洋保险蓝医保百万医疗险(20年保证续保)
		NETM6938MP: true, // 复星联合妈咪保贝爱常在少儿重大疾病保险（互联网）
		NETM6341QS: true, // 同方全球「臻爱2023」互联网定期寿险
		NETM9314ZF: true, // 同方全球「臻爱2024」互联网定期寿险
		NETM5099ML: true, // 复星联合超级玛丽真多次重大疾病保险
		NETM6828JH: true, // 中国人保金医保3号百万医疗险
		NETM7736UL: true, // 复星保德信大黄蜂13号少儿重疾险(旗舰版)
		NETM6193VP: true, // 太平洋保险大护甲7号意外险(家庭版)
		NETM5192XD: true, // 太保人寿蛮好的人生年金保险(互联网)
		NETM8501LE: true, // 中国人保大护甲7号意外险（旗舰版）
		NETM8693EH: true, // 君龙人寿超级玛丽13号百万重大疾病保险
		NETM0216NB: true, // 众安尊享e生·中高端医疗保险PLUS
		NETM2400DH: true, // 复星保德信大黄蜂15号少儿重疾险(旗舰版)
		NETM5099ML: true, // 复星联合超级玛丽真多次重大疾病保险
		NETM6828JH: true, // 中国人保金医保3号百万医疗险
		NETM7736UL: true, // 复星保德信大黄蜂13号少儿重疾险(旗舰版)
		NETM6193VP: true, // 太平洋保险大护甲7号意外险(家庭版)
		NETM5192XD: true, // 太保人寿蛮好的人生年金保险(互联网)
		NETM8501LE: true, // 中国人保大护甲7号意外险（旗舰版）
		NETM0326UQ: true, // 中国人保大护甲7号意外险（易投版）
		NETM8693EH: true, // 君龙人寿超级玛丽13号百万重大疾病保险
		NETM0216NB: true, // 众安尊享e生·中高端医疗保险PLUS
		NETM2400DH: true, // 复星保德信大黄蜂15号少儿重疾险(旗舰版)
		NETM4667IM: true, // 复星保德信大黄蜂16号少儿重疾险(旗舰版)
		NETM6861KL: true, // 平安保险希望之星3号学平险（2025）
		NETM4542JP: true, // 中国平安小顽童7号少儿意外险
		NETM9202ZX: true, // 君龙人寿超级玛丽15号百万重大疾病保险
		NETM6917FZ: true, // 太保蛮好的人生（2025）年金保险（互联网）
	},
	PICCGI: {
		NETM1370TQ: true,
		NETM0988AU: true,
	},
	CHIC: {
		NETM9848QR: true, //肺康宝·肺部恶性肿瘤医疗保险 
	},
	liberty: {
		NETM8192BS: true,
	},
	zhongdal: {
		ALAXWLJWLXQQBYWX: true, //安联安行万里境外旅行险（互联网）全球版
		ALAXWLJWLXOZBYWX: true, //安联安行万里境外旅行险（互联网）欧洲版
		ALAXWLJWLXDNYYWX: true, //安联安行万里境外旅行险（互联网）东南亚版
	},
	HTPC: {
		NETM3891QK: true, //AON尊长无忧老年意外险
		NETM3300QT: true, //丽人守护女性特定疾病险
	},
    trustlife: {
        MITM9807PR: true, //信美相互医家医保障计划
    },
	renbjk: {
		NETM0625TX: true, // 人保健康长相守互联网终身护理保险（B款）（税优版）
		NETM0001RP: true, // 人保健康易欣守护互联网医疗保险
		NETM2295WG: true, // 人保健康长相守互联网终身护理保险（2025款）
	},
    BJLIFE: {
        NETM8652WU: true, //小福娃少儿重疾保险计划
        NETM4115GE: true, // 北京人寿小福娃2号少儿重疾保障计划
		NETM4383DR: true, // 北京人寿小福娃2号（守护版）少儿重疾保障计划（互联网专属）
    },
	picclife: {
		NETM5906WZ: true, // 人保寿险i无忧3.0重大疾病保险（互联网专属）
		NETM8053XV: true, // 人保寿险无敌宝宝2.0少儿重大疾病保险（互联网专属）
	},
    JUNLONG: {
        NETM2427WR: true, // 君龙小青龙6号怡享版少儿重大疾病保险
        NETM6856ZR: true, // 君龙小青龙7号A款少儿重大疾病保险
		NETM6168XF: true, // 君龙小青龙8号A款少儿重大疾病保险
		NETM2761HQ: true, // 君龙小青龙8号D款少儿重大疾病保险
		MITM7668JI: true, // 君龙龙抬头（享福版）养老年金保险，电投产品，适当性问卷
		NETM5703CY: true, // 君龙龙回首3号A款特定疾病保险（互联网）
		NETM4855GP: true, // 君龙龙回首3号B款特定疾病保险（互联网）
    },
	zhongh: {
		NETM9105ME: true, // 中荷互联网岁岁享2.0护理保险
		NETM2127AM: true, // 中荷互联网岁岁享3.0护理保险
		NETM2788BF: true, // 中荷互联网金享事成（优享版）终身寿险
		NETM9063YL: true, // 中荷互联网金生岁享3.0养老年金保险
	},
	dicchina: {
		NETM6314ZJ: true, // 牧原生猪货运险
	},
	yangg: {
		MITM8211BL: true, // 阳光人寿鑫悦双享年金保险（分红型）
		MITM5774VM: true, // 阳光人寿鑫满益两全保险
		MITM1926PX: true, // 阳光人寿鑫满益两全保险
		MITM0904TZ: true, // 阳光人寿颐享金升2025养老年金保险（分红型）
		MITM8105SI: true, // 阳光人寿鑫享益两全保险（分红型）
		MITM8242JQ: true, // 阳光人寿鑫悦相伴终身寿险（分红型）
	}
} as object;

export const onGluttonHandled = (options: {
	vendorCode: string;
	productCode: string;
	productVersion: string;
}): boolean => {
	const { vendorCode, productCode, productVersion } = options;
	if (!vendorCode) {
		return false;
	}
	//@ts-ignore
	const vendorCodeValue = GluttonProducts[vendorCode] as any;
	if (Utils.isBoolean(vendorCodeValue)) {
		return vendorCodeValue;
	}
	if (!vendorCodeValue) {
		return false;
	}
	if (!productCode) {
		return false;
	}
	const productCodeValue = (vendorCodeValue || {})[productCode];
	if (Utils.isBoolean(productCodeValue)) {
		return productCodeValue;
	}
	if (!productCodeValue) {
		return false;
	}
	if (!productVersion) {
		return false;
	}
	const productVersionValue = (productCodeValue || {})[productVersion];
	if (Utils.isBoolean(productVersionValue)) {
		return productVersionValue;
	}
	if (!productVersionValue) {
		return false;
	}
	const { tenantCode } = Envs.findAccount();
	if (!tenantCode) {
		return false;
	}
	const tenantValue = (productVersionValue || {})[tenantCode];
	if (Utils.isBoolean(tenantValue)) {
		return tenantValue;
	}
	if (!tenantValue) {
		return false;
	}
	return false;
}
